
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1iee7_xy9l5_145",
  "announcer": "awsui_announcer_1iee7_xy9l5_153"
};
  